import Api from '@/services/Api'

export default {
  getGoods (uid) {
    return Api().post('', {
      command: 'Goods',
      UID: uid})
  },
  getGoodsABCXYZ () {
    return Api().post('', {
      command: 'goodsABCXYZ'})
  },
  getGoodsReserves () {
    return Api().post('', {
      command: 'goodsReserves'})
  },
  goodsSalesByPeriod (startDate, endDate) {
    return Api().post('', {
      command: 'getGoodsSalesByPeriod',
      StartDate: startDate,
      EndDate: endDate
    })
  },
  goodSalesByPeriod (UID, startDate, endDate) {
    return Api().post('', {
      command: 'getGoodSalesByPeriod',
      StartDate: startDate,
      EndDate: endDate,
      UID: UID
    })
  },
  getDeliverySchemes () {
    return Api().post('', {
      command: 'deliverySchemes'})
  },
  createSupplierOrder () {
    return Api().post('', {
      command: 'createSupplierOrder'})
  },
  getSupplierOrders () {
    return Api().post('', {
      command: 'getSupplierOrders'})
  },
  patchSupplierOrder (uid, jsonString, dataVersion) {
    return Api().post('', {
      command: 'patchSupplierOrder',
      orderId: uid,
      jsonString: jsonString,
      dataVersion: dataVersion })
  },
  getClientBalance (partnerId, days) {
    return Api().post('', {
      command: 'getClientBalance',
      partnerId: partnerId,
      days: days})
  },
  getContragents () {
    return Api().post('', {
      command: 'contragents'
    })
  },
  getOrderList (uid) {
    return Api().post('', {
      command: 'GetOrdersList',
      UID: uid})
  },
  auth (uid) {
    return Api().post('', {
      command: 'Auth',
      UID: uid})
  },
  getFolders () {
    return Api().post('', {
      command: 'folders'
    })
  },
  authMNG (uid, info) {
    return Api().post('', {
      command: 'AuthorizationMNG',
      UID: uid,
      info: info})
  },
  partnerABCXYZ (uid) {
    return Api().post('', {
      command: 'partnerABCXYZ',
      UID: uid})
  },
  managers () {
    return Api().post('', {
      command: 'getManagers'
    })
  },
  partnersABCXYZ () {
    return Api().post('', {
      command: 'partnersABCXYZ'
    })
  },
  partnersSalesByPeriod (startDate, endDate) {
    return Api().post('', {
      command: 'getPartnersSalesByPeriod',
      StartDate: startDate,
      EndDate: endDate
    })
  },
  partnersSalesByPeriodShort (startDate, endDate) {
    return Api().post('', {
      command: 'getPartnersSalesByPeriodShort',
      StartDate: startDate,
      EndDate: endDate
    })
  },
  partnersSalesByYear (year) {
    return Api().post('', {
      command: 'getPartnersSalesByYear',
      Year: year })
  },
  partnerSalesByYear (uid, year) {
    return Api().post('', {
      command: 'getPartnerSalesByYear',
      UID: uid,
      Year: year })
  },
  partnerSalesByYearByGoods (uid, year) {
    return Api().post('', {
      command: 'getPartnerSalesByYearByGoods',
      UID: uid,
      Year: year })
  },
  partnersSalesByYearByGoods (year) {
    return Api().post('', {
      command: 'getPartnersSalesByYearByGoods',
      Year: year })
  },
  partnerSalesByYearByGroups (uid, year) {
    return Api().post('', {
      command: 'getPartnerSalesByYearByGroups',
      UID: uid,
      Year: year })
  },
  createOrder (partnerId, contragentId, agreement) {
    return Api().post('', {
      command: 'createOrder',
      partnerId: partnerId,
      contragentId: contragentId,
      agreement: agreement})
  },
  patchOrder (Id, String, Version) {
    return Api().post('', {
      command: 'patchOrder',
      orderId: Id,
      jsonString: String,
      dataVersion: Version})
  },
  postOrder (orderId, comm, message, Version, maxline) {
    return Api().post('', {
      command: 'setOrderPosted',
      orderId: orderId,
      message: message,
      comment: comm,
      dataVersion: Version,
      maxline: maxline })
  },
  getSkorpionoCatalog (uid) {
    return Api().post('', {
      command: 'getSkorpionoFolders',
      UID: uid
    })
  },
  getSkorpionoPictures () {
    return Api().post('', {
      command: 'getSkorpionoPictures'
    })
  },
  getExchangeRate () {
    return Api().post('', {
      command: 'getExchangeRate'
    })
  },
  createGood (article, description) {
    return Api().post('', {
      command: 'createGood',
      article: article,
      description: description
    })
  },
  createConversation (partnerUid, partnerName, managerUid, phone, tag, message) {
    return Api().post('', {
      command: 'createConversation',
      partner_uid: partnerUid,
      partner_name: partnerName,
      manager_uid: managerUid,
      phone: phone,
      tag: tag,
      message: message
    })
  },
  getPhone (partnerUid) {
    return Api().post('', {
      command: 'getPhone',
      partner_uid: partnerUid
    })
  },
  getPhoneCalls () {
    return Api().post('', {
      command: 'getPhoneCalls'
    })
  },
  getBusinessRegions () {
    return Api().post('', {
      command: 'getBusinessRegions'
    })
  },
  getPartnersSalesByDate (EndDate) {
    return Api().post('', {
      command: 'getPartnersSalesByDate',
      EndDate: EndDate
    })
  },
  getPartnersPayments () {
    return Api().post('', {
      command: 'getPartnersPayments'
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/ApiService.js